import iphoneFrame from '@/assets/marketing/iphone-frame.png';

/**
 * Insets match learn-hmong/screenshots/templates/shared.css so the raw
 * device shot fills the iphone-frame.png glass hole.
 */
const SCREEN_INSET_X = '5.33%';
const SCREEN_INSET_Y = '2.50%';
const SCREEN_RADIUS = '14.6% / 7.15%';

type FramedPhoneProps = {
  src: string;
  alt: string;
  className?: string;
};

export function FramedPhone({ src, alt, className = '' }: FramedPhoneProps) {
  return (
    <div
      className={`relative ${className}`}
      style={{
        width: '100%',
        aspectRatio: '1350 / 2760',
        filter: 'drop-shadow(0 16px 22px rgba(31, 86, 16, 0.22)) drop-shadow(0 3px 8px rgba(0, 0, 0, 0.12))',
      }}
    >
      <div
        className="absolute overflow-hidden bg-black"
        style={{
          left: SCREEN_INSET_X,
          right: SCREEN_INSET_X,
          top: SCREEN_INSET_Y,
          bottom: SCREEN_INSET_Y,
          borderRadius: SCREEN_RADIUS,
        }}
      >
        <img src={src} alt={alt} className="h-full w-full object-cover object-top" />
      </div>
      <img src={iphoneFrame} alt="" className="pointer-events-none absolute inset-0 h-full w-full select-none" />
    </div>
  );
}

type Screen = { src: string; alt: string };

export function PhoneTrio({ screens, label }: { screens: [Screen, Screen, Screen]; label: string }) {
  return (
    <div className="relative mx-auto aspect-[4/5] w-full max-w-[300px]" role="img" aria-label={label}>
      <div className="absolute left-[-2%] top-[6%] z-0 w-[46%] origin-top rotate-[-8deg]">
        <FramedPhone src={screens[0].src} alt="" />
      </div>
      <div className="absolute right-[-2%] top-[6%] z-[1] w-[46%] origin-top rotate-[8deg]">
        <FramedPhone src={screens[2].src} alt="" />
      </div>
      <div className="absolute left-1/2 top-[14%] z-[2] w-[50%] -translate-x-1/2">
        <FramedPhone src={screens[1].src} alt="" />
      </div>
    </div>
  );
}

export function PhoneDuo({ screens, label }: { screens: [Screen, Screen]; label: string }) {
  return (
    <div className="relative mx-auto aspect-[4/5] w-full max-w-[300px]" role="img" aria-label={label}>
      <div className="absolute left-[-4%] top-[4%] z-0 w-[54%] origin-[50%_20%] rotate-[-7deg]">
        <FramedPhone src={screens[0].src} alt="" />
      </div>
      <div className="absolute right-[-4%] top-[12%] z-[1] w-[54%] origin-[50%_20%] rotate-[7deg]">
        <FramedPhone src={screens[1].src} alt="" />
      </div>
    </div>
  );
}
